import { Chip, styled } from '@mui/material';
import defaultChipStyles from 'common/theme/chips/defaultChipStyles';

const StyledClientOptionChip = styled(Chip)(({ theme }) => ({
  ...defaultChipStyles,
  marginLeft: theme.spacing(2)
}));

export default StyledClientOptionChip;
